import mock from './mock'
import './tables/datatables'
import './cards/card-analytics'
import './cards/card-statistics'

mock.onAny().passThrough()
